import { useCallback, useState } from "react";
import { TellescopeModelFromName } from "@tellescope/tanstack-query";
import { BlockProps } from "../types";
import { useBlock } from ".";

export interface UseMedicationsBlockArgs extends BlockProps {}

export const useMedicationsBlock = (args: UseMedicationsBlockArgs) => {
  const block = useBlock({ ...args, type: "medications.medications", select: (enduser) => enduser });

  const [showUploadForm, setShowUploadForm] = useState(false);
  const [selectedMedication, setSelectedMedication] = useState<TellescopeModelFromName<"enduser_medications">>();

  const openUploadForm = useCallback(() => {
    setSelectedMedication(undefined);
    setShowUploadForm(true);
  }, []);
  const closeUploadForm = useCallback(() => setShowUploadForm(false), []);

  const openMedication = useCallback(
    (medication: TellescopeModelFromName<"enduser_medications">) => setSelectedMedication(medication),
    []
  );
  const closeMedication = useCallback(() => setSelectedMedication(undefined), []);

  const enduser = block.enduserQuery.data;

  return {
    ...block,
    enduser,
    showUploadForm,
    openUploadForm,
    closeUploadForm,
    selectedMedication,
    openMedication,
    closeMedication,
  };
};
